import { useEffect, useMemo } from 'react';

import { useQuery } from '@apollo/client';
import * as _ from 'lodash';
import Select from 'react-select';

import OptVersionsByReportIdQuery, {
  OptVersionsByReportIdResponse,
} from '../../../graphql/queries/OptVersionsByReportIdQuery';
import { versionPickerSelectStyles } from '../useStyles';

interface VersionPickerProps {
  reportId: string;
  onChange: (reportId: string, versions: string[]) => void;
  disabled?: boolean;
  value?: string[];
}

//AIPD-885 component to select version for opt reports
const VersionPicker: React.FC<VersionPickerProps> = ({
  reportId,
  onChange,
  disabled,
  value=[],
}) => {
  const { data, loading } = useQuery<OptVersionsByReportIdResponse>(
    OptVersionsByReportIdQuery,
    { variables: { reportId } },
  );

  const versionOptions = useMemo(() => {
    if (!data) return [];
    return _.uniq(data.allReportSummaries.nodes.map((n) => n.version))
      .sort()
      .map((v) => ({ label: v, value: v }));
  }, [data]);

  useEffect(() => {
    if (versionOptions.length > 0 && value.length === 0) {
      onChange(reportId, [versionOptions[0].value]);
    }
  }, [versionOptions]);

  if (loading) return <div>Loading versions...</div>;
  if (!versionOptions.length) return <div>No versions available</div>;

  return (
    <Select
      options={versionOptions}
      isMulti
      value={versionOptions.filter((option) => value.includes(option.value))}
      placeholder="Select versions"
      isDisabled={disabled}
      onChange={(selected) =>
        onChange(reportId, (selected || []).map((s) => s.value))
      }
      styles={versionPickerSelectStyles}
    />
  );
};

export default VersionPicker;